import React from "react";
import { useModalDispatch, ModalForm } from "collections/Modal";
import { Field, Checkbox, Form } from "collections/Form";
import { useTranslation } from "utilities/i18n";
import { useSelector } from "react-redux";
import { State } from "store";
import { formatISO } from "date-fns";
import { useUserMeta } from "utilities/userMeta";
import * as yup from "yup";
import { InferType } from "yup";
import { SubmitButton } from "elements";
import "./SiteDetails.scss";

const schema = yup.object({
  doNotShowAgain: yup.boolean().required()
});
type SubnetModalType = InferType<typeof schema>;

export const SubnetInstructionsModal: React.FC = () => {
  const [setUserMeta] = useUserMeta();
  const subnetInstructions = useSelector((state: State) => {
    return state.userMeta?.subnetInstructions;
  });
  const { t } = useTranslation();
  const dispatchEvent = useModalDispatch();

  if (subnetInstructions) {
    return <></>;
  }

  const handleOnClose = ({ doNotShowAgain }: SubnetModalType) => {
    if (doNotShowAgain) {
      setUserMeta({
        subnetInstructions: formatISO(new Date(), {
          representation: "date"
        }).replace(/_/g, "_")
      });
    }
    dispatchEvent();
  };

  return (
    <ModalForm<SubnetModalType>
      title={t("UNASSIGNED_DEVICES")}
      name="UnassignedSiteInstructions"
      validationSchema={schema}
      initialValues={{
        doNotShowAgain: false
      }}
      onSubmit={handleOnClose}
    >
      {({ isSubmitting }) => (
        <div
          className="subnet-instructions-modal font-xs"
          data-testid="subnet-instructions-modal"
        >
          <div>
            <p>{t("UNASSIGNED_DEVICES_P0")}</p>
            <p className="mb-0">
              <b>{t("UNASSIGNED_DEVICES_MANUAL")}</b>
            </p>
            <div>
              <p className="mb-0 inline-block">
                <b>1.</b>
              </p>
              <p className="mb-0 pl-1 inline-block">
                {t("UNASSIGNED_DEVICES_MANUAL_1")}
              </p>
            </div>
            <div>
              <p className="mb-0 inline-block">
                <b>2.</b>
              </p>
              <p className="mb-0 pl-1 inline-block">
                {t("UNASSIGNED_DEVICES_MANUAL_2")}
              </p>
            </div>
            <div>
              <p className="mb-0 inline-block">
                <b>3.</b>
              </p>
              <p className="mb-0 pl-1 inline-block">
                {t("UNASSIGNED_DEVICES_MANUAL_3")}
              </p>
            </div>
            <div>
              <p className="mb-0 inline-block">
                <b>4.</b>
              </p>
              <p className="mb-0 pl-1 inline-block">
                {t("UNASSIGNED_DEVICES_MANUAL_4")}
              </p>
            </div>
            <div>
              <p className="mb-0 inline-block">
                <b>5.</b>
              </p>
              <p className="pl-1 inline-block">
                {t("UNASSIGNED_DEVICES_MANUAL_5")}
              </p>
            </div>
            <p className="mb-0">
              <b>{t("UNASSIGNED_DEVICES_IP")}</b>
            </p>
            <div>
              <p className="mb-0 inline-block">
                <b>1.</b>
              </p>
              <p className="pl-1 mb-0 inline-block">
                {t("UNASSIGNED_DEVICES_IP_1")}
              </p>
            </div>
            <div>
              <p className="mb-0 inline-block">
                <b>2.</b>
              </p>
              <p className="pl-1 mb-0 inline-block">
                {t("UNASSIGNED_DEVICES_IP_2")}
              </p>
            </div>
            <div>
              <p className="mb-0 inline-block">
                <b>3.</b>
              </p>
              <p className="pl-1 mb-0 inline-block">
                {t("UNASSIGNED_DEVICES_IP_3")}
              </p>
            </div>
            <div>
              <p className="mb-0 inline-block">
                <b>4.</b>
              </p>
              <p className="pl-1 mb-0 inline-block">
                {t("UNASSIGNED_DEVICES_IP_4")}
              </p>
            </div>
            <div>
              <p className="mb-0 inline-block">
                <b>5.</b>
              </p>
              <p className="pl-1 inline-block">
                {t("UNASSIGNED_DEVICES_IP_5")}
              </p>
            </div>
          </div>
          <Form className="grid">
            <label className="checkbox-label pv-0 pl-25 col-11">
              <Field name="doNotShowAgain" as={Checkbox} />
              <p className="mb-0 font-regular">{t("DO_NOT_SHOW_AGAIN")}</p>
            </label>
            <div className="text-right">
              <SubmitButton
                isSubmitting={isSubmitting}
                testId="instructions-modal-button"
                labelKey="CLOSE"
                submittingLabelKey="CLOSE"
              />
            </div>
          </Form>
        </div>
      )}
    </ModalForm>
  );
};

export default SubnetInstructionsModal;
